import React from 'react'
import PropTypes from 'prop-types'

import { Link } from 'react-router'

import CardProperty from 'Components/CardProperty'

const CardPropertyLink = props => {
  const { linkTo } = props

  if (linkTo) {
    return (
      <Link to={linkTo}>
        <CardProperty {...props} />
      </Link>
    )
  }

  return (
    /* eslint-disable-next-line */
    <a>
      <CardProperty {...props} />
    </a>
  )
}

CardPropertyLink.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  linkTo: PropTypes.string,
  onClick: PropTypes.func,
  popUpContent: PropTypes.node.isRequired,
}

export default CardPropertyLink
